import { StoreTypes } from '@/types/types'

interface LocalStorageSchema {
  token: string | null
  authSource: string | null
  id: string | null
  type: StoreTypes | null
  storeName: string | null
  currencyCode: string | null
  currencySymbol: string | null
  username: string | null
  avatar: string | null
  availability: string | null
  usingCashCo: boolean | null
  storeLedgerWalletEnabled: boolean | null
  settings: {
    confirmMenuHideAction: boolean
  }
  phoneNumber: string | null
  phoneCode: string | null
  orderNotifications: Array<string> | null
  selectedBranchId: string 
  clarityDeviceId: string | null
}

export function setToLocalStorage(obj: Partial<LocalStorageSchema>): void {
  Object.entries(obj).forEach(([key, value]) => {
    const stringifiedValue = JSON.stringify(value)
    localStorage.setItem(key, stringifiedValue)
  })
}

export function readFromLocalStorage<T extends keyof LocalStorageSchema>(
  key: T
): LocalStorageSchema[T] | null {
  const storedValue = localStorage.getItem(key)

  if (storedValue === null) return null

  try {
    return JSON.parse(storedValue) as LocalStorageSchema[T]
  } catch (e) {
    return storedValue as LocalStorageSchema[T]
  }
}

export function removeFromLocalStorage<T extends keyof LocalStorageSchema>(
  ...keys: T[]
): void {
  keys.forEach(key => localStorage.removeItem(key))
}
